import { image } from "components/ArtWork/GangstaStats";
import { GANGSTA_BET_11, LADY } from "src/constants/images";
import { useNavigate } from "react-router-dom";
import React from "react";
import { MARKET_PLACE, PROFILE } from "src/constants/routes";
import { nFormatter } from "utils/nFormatter";
export default function AlleywayGCard({
  token_uri,
  token_name,
  class_type,
  skills,
  salePrice,
  total_stats,
  key,
  token_id,
}) {
  const navigate = useNavigate();

  const clickHandler = (e) => {
    console.log(e.target.classList.value.toString());
    if (e.target.classList.value.toString().includes("class-type")) {
      navigate(`${MARKET_PLACE.INDEX}?class_type=${class_type}`);
      window.location.reload();
    } else {
      const route = PROFILE.addSlug(PROFILE.INDEX, parseInt(token_id));
      navigate(route);
    }
  };
  return (
    <div className="awg-card" key={key} onClick={clickHandler}>
      <div className="d-flex">
        <div className="awg-img-box">
          <img src={token_uri} />
        </div>
        <div className="awg-info-box">
          <h5>{token_name} </h5>
          <div
            className={`gangsta-class-type al-badge ${class_type.toLowerCase()}`}
          >
            {class_type}
          </div>
          {salePrice >= 0 ? (
            <div className="gangsta-sale">
              <div className="gangsta-price d-flex">
                {/* <div className="dot">&#183;</div> */}

                {
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 120 120"
                    xmlns="http://www.w3.org/2000/svg"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    stroke-linejoin="round"
                    stroke-miterlimit="2"
                  >
                    <g transform="translate(-135)" fill="#2ca9b7">
                      <path
                        d="M233.5 31.4l-13 13c2.8 4.6 4.4 9.9 4.4 15.7 0 16.6-13.4 30-30 30-5.7 0-11.1-1.6-15.7-4.4l-13 13c8 5.9 17.9 9.5 28.6 9.5 26.5 0 48-21.5 48-48 .2-10.9-3.3-20.8-9.3-28.8zM165 60c0-16.6 13.4-30 30-30 5.7 0 11.1 1.6 15.7 4.4l13-13c-8-5.9-17.9-9.5-28.6-9.5-26.5 0-48 21.5-48 48 0 10.7 3.5 20.6 9.5 28.6l13-13c-3-4.4-4.6-9.8-4.6-15.5z"
                        fill-rule="nonzero"
                      />
                      <circle cx="243" cy="12" r="12" />
                      <circle cx="147" cy="108" r="12" />
                    </g>
                  </svg>
                }
                <div className="price-value">{nFormatter(1230000)}</div>
                <div className="price-unit">ICX</div>
              </div>
            </div>
          ) : (
            <div className="price-replacement awg-stat-box">
              <div className=" d-flex skill-stat">
                <div>Skill :</div>
                <strong style={{ color: "#1F2431" }}>{total_stats}</strong>
              </div>
              <div className="skill-icon-box">
                {Object.keys(skills).map((key, index) => (
                  <img style={{ left: `${index * 15}px` }} src={image(key)} />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
      {salePrice >= 0 ? (
        <div className="side awg-stat-box">
          <div className=" d-flex skill-stat">
            <div>Skill :</div>
            <strong style={{ color: "#1F2431" }}>{total_stats}</strong>
          </div>
          <div className="skill-icon-box">
            {Object.keys(skills).map((key, index) => (
              <img style={{ left: `${index * 15}px` }} src={image(key)} />
            ))}
          </div>
        </div>
      ) : (
        <div className="price-replacement-side awg-stat-box">
          <div className=" d-flex skill-stat">
            <div>Skill :</div>
            <strong style={{ color: "var(--total-stats-text)" }}>
              {total_stats}
            </strong>
          </div>
          <div className="skill-icon-box">
            {Object.keys(skills).map((key, index) => (
              <img style={{ left: `${index * 15}px` }} src={image(key)} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
